export function isLinkableValue(model) {
    return !Array.isArray(model);
}
export function isProtocolLink(model) {
    return (model !== undefined &&
        typeof model !== 'string' &&
        typeof model !== 'boolean' &&
        typeof model !== 'number' &&
        !Array.isArray(model));
}
export default class ProtocolContentData {
}
//# sourceMappingURL=ProtocolContentData.js.map